/*
 * Notice: This software is proprietary to Pocketbook, its affiliates, partners and/or
 * licensors. Unauthorized copying, distribution or use is strictly prohibited.
 * All rights reserved.
 */

'use strict';

angular.module('webReader')
    .directive('contentbuilder', ["$compile", function ($compile) {
        return {
            scope: {
                collectionNode: '=',
                sectionIndex: '='
            },
            restrict: 'E',
            replace: true,
            templateUrl: 'directives/contentbuilder/contentbuilder.view.html',
            link: function ($scope, element) {
                // console.log($scope.collectionNode,' link');
                $scope.collectionNode && element.append($compile('<chapterslist collection-node="collectionNode" parent-node="true" section-index="sectionIndex"></chapterslist>')($scope));
            }
        };
    }]);